<template>
  <div class="hello">
    <div class="header">
      <img height="256px" width="256px"  alt="Vue logo" src="../assets/logo.png">
      <h1>{{ msg }}</h1>
      <h3>
        Loughati is committed to protecting your privacy. We do not collect or use any personal data. Everything you use and save in the app is saved on your local device.
        You stay responsible for everything you save on the APP.
      </h3>  
    </div>
    <div class="body">
      <h2>IF YOU DO NOT AGREE WITH THE TERMS OF THIS PRIVACY POLICY, YOU ARE ADVISED NOT TO CONTINUE USING THE APP ANY LONGER.</h2>
      <h1>WHAT INFORMATION DO WE COLLECT?</h1>
        <h4>We do not collect any information</h4>
      <h1>DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</h1>
      <h4>No, Loughati app do not use any cookie or tracking technologie.</h4>
      <div>
        <h1>Contact us :</h1>
        <h4>email : eateamcompany@gmail.com</h4>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  background-color: blueviolet;
}
.header h1,h3 {
  color: white;
} 
.body {
  text-align: start;
  color: black;
}  
</style>
